import {TOGGLE_NAVBAR, STORE_PARENT} from "./actionTypes";

const initialState = {
  isNavbarShowing: true,
  parent_id: 0
};

const reducer = (state = initialState, action) => {
  if (action.type === TOGGLE_NAVBAR) {
    return {
      ...state,
      isNavbarShowing: !state.isNavbarShowing
    };
  }else {
    return state
  }
};

export default reducer;